import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import { Paper } from '@mui/material';
import Typography from '../Typography';
import ButtonBase from '@mui/material/ButtonBase';
import cx from 'classnames';
import { compose } from '../../reactApolloCompat';
import ValidationBadges from '../ValidationBadges';

class TabbedModal extends Component {
    static defaultProps = {
        onClose: () => {}
    };

    state = {};

    render() {
        const {
            classes,
            className,
            contentClassName,
            tabs,
            onChange,
            children,
            open,
            fullScreen,
            ...other
        } = this.props;

        return (
            <Dialog
                disableEscapeKeyDown={true}
                className={classes.diagRoot}
                classes={{ paper: cx(className, classes.root, { [classes.rootFullScreen]: other.fullScreen }) }}
                open={open}
                fullScreen={fullScreen}
            >
                <div className={classes.tabHeaders}>{tabs.map(this.renderTabButton)}</div>
                <Paper className={cx(classes.paper, contentClassName)} elevation={0}>
                    {children}
                </Paper>
            </Dialog>
        );
    }

    renderTabButton = (tab, index) => {
        const { classes, tabIndex, onChange, tabs } = this.props;
        const highlighted = tabIndex !== index;
        const tabLabel = tabs[index].label || tab;
        const tabKey = tabs[index].key || tab;
        return (
            <ButtonBase
                focusRipple
                disabled={!highlighted}
                className={cx(classes.tabButton, { [classes.tabButtonHighlighted]: !highlighted })}
                key={index}
                onClick={() => onChange(index)}
            >
                <Typography variant="headline">{tabLabel}</Typography>
                <ValidationBadges tabID={tabKey} />
            </ButtonBase>
        );
    };
}

const styles = ({ palette, spacing, typography, breakpoints, funeralHome }) => ({
    diagRoot: {
        overflowY: 'auto'
    },
    root: {
        background: 'none',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        overflow: 'hidden',
        maxWidth: '95vw',
        maxHeight: '95vh',
        margin: spacing(1)
    },
    rootFullScreen: {
        justifyContent: 'center',
        height: 'auto',
        maxHeight: 'unset'
    },
    paper: {
        borderRadius: 8,
        borderTopLeftRadius: '0!important',
        padding: 0,
        // overflowY: 'auto',
        // padding: '42px',
        // display: 'flex',
        background: palette.common.white,
        [breakpoints.down('sm')]: {
            borderRadius: '0 0 8px 8px'
        }
    },
    tabHeaders: {
        padding: 0,
        paddingRight: spacing(3),
        display: 'flex',
        flexWrap: 'wrap',
        [breakpoints.down('sm')]: {
            background: palette.common.white,
            padding: '12px 12px 0 12px',
            borderRadius: '8px 8px 0 0'
        }
    },
    tabButton: {
        flex: '0 0 auto',
        padding: 36,
        backgroundColor: palette.basePrimary[funeralHome],
        borderBottom: `2px solid ${palette.basePrimary[funeralHome]}`,
        borderLeft: `1px solid #00000033`,
        '& > h5': {
            color: palette.common.white,
            fontWeight: typography.fontWeightLight,
            [breakpoints.down('md')]: {
                fontSize: '0.875rem'
            }
        },
        '&:first-child': {
            borderTopLeftRadius: 8,
            borderLeft: 0
        },
        '&:last-child': {
            borderTopRightRadius: 8
        },
        [breakpoints.down('lg')]: {
            padding: 20,
            flex: '1 0 auto'
        },
        [breakpoints.down('sm')]: {
            display: 'none',
            padding: 5,
            width: '100%',
            borderLeft: 0,
            backgroundColor: palette.basePrimary[funeralHome] + '99',
            '&:first-child': {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0
            },
            '&:last-child': {
                borderTopRightRadius: 0
            }
        }
    },
    tabButtonHighlighted: {
        backgroundColor: palette.common.white,
        [breakpoints.down('sm')]: {
            display: 'block',
            backgroundColor: palette.common.white
        },
        '& > h5': {
            color: palette.basePrimary[funeralHome],
            fontWeight: typography.fontWeightMedium,
            [breakpoints.down('sm')]: {
                fontSize: '1.125rem',
                opacity: 1
            }
        }
    },
    loading: {},
    modalMagick: {}
});

export default compose(withTheme, withStyles(styles))(TabbedModal);
